import React, { useState, useEffect} from 'react';

import cloneDeep from 'lodash/cloneDeep';

import post from '../logic/Loader';
import GlobalData from '../logic/GlobalData';
import {saveCookieObj, readCookieObj} from '../logic/Cookie';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';

import 'react-perfect-scrollbar/dist/css/styles.css';

import PerfectScrollbar from 'react-perfect-scrollbar'

const useConstructor = (callBack = () => {}) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  callBack();
  setHasBeenCalled(true);
}

const daysDiff = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
    return TotalDays;
}

export default function Words(props) {

  let scrollBarRef:any = false;

  const [groups, setGroups] = React.useState([]);
  const [words, setWords] = React.useState([]);
  const [activeGroupId, setActiveGroupId] = React.useState(false);
  const [activeGroup, setActiveGroup] = React.useState(false);
  const [showAllWords, setShowAllWords] = React.useState(true);

  const [activeWordId, setActiveWordId] = React.useState(0);

  const [mode, setMode] = React.useState('groups');

  const [voice, setVoice] = React.useState(GlobalData.settings.voice);
  const [volume, setVolume] = React.useState(parseFloat(GlobalData.settings.volume));
  const [lang, setLang] = React.useState(GlobalData.settings.lang);

  const [variants, setVariants] = React.useState([]);

  const [results, setResults] = React.useState({'error':[], 'ok':[], 'proc':''});

  const [stat, setStat] = React.useState({});

  const [isError, setIsError] = React.useState(false);
  const [readyAnswer, setReadyAnswer] = React.useState(false);
  const [onlyError, setOnlyError] = React.useState(false);

  const [styles, setStyles] = React.useState({});

  const voiceChange = (
    event: React.MouseEvent<HTMLElement>,
    newVoice: string,
  ) => {
    GlobalData.settings.voice = newVoice;
    saveCookieObj('settings', GlobalData.settings);
    setVoice(newVoice);
  };

  const langChange = (
    event: React.MouseEvent<HTMLElement>,
    newLang: string,
  ) => {

    if(GlobalData.busy)
      return;

    GlobalData.settings.lang = newLang;
    saveCookieObj('settings', GlobalData.settings);
    setLang(newLang);

    let params = {
      lang: GlobalData.settings.lang
    };

    post('/post/words/getdata/', params, (data) => {
      GlobalData.data.words = data.words;

      let translates_types = ['noun', 'adjective', 'verb', 'auxiliary_verb', 'adverb', 'preposition', 'conjunction', 'suffix', 'abbreviation', 'pronoun', 'phrase', 'article', 'particle', 'def_translate'];

      if(activeGroupId) {

        applyVoice(activeGroupId);

        let new_words = cloneDeep(words);

        new_words.forEach((word) => {

          let need_word = false;

          GlobalData.data.words[activeGroupId].every((search_word) => {
            if(search_word.id == word.id) {
              need_word = search_word;
              return false;
            }

            return true;
          });

          if(need_word)
            translates_types.forEach((translates_type) => {
              word[translates_type] = need_word[translates_type];
            });
        });

        setWords(new_words);
      }

      GlobalData.busy = false;
    });
  };

  const changeVolume = (event: Event, newValue: number | number[]) => {
    GlobalData.settings.volume = newValue;
    saveCookieObj('settings', GlobalData.settings);
    setVolume(newValue as number);
  };

  useEffect(() => {
    if(activeGroupId) {
      applyVoice(activeGroupId);
    }
  },[voice]);

  useEffect(() => {
    if(readyAnswer) {
      if(mode == "game_write" || mode == "game_hear") {
        document.querySelector('.variants input.en').focus();
        document.querySelector('.variants input.en').click();
      }
    }
  },[readyAnswer]);

  // useEffect(() => {

  //   switch(mode) {
  //     case 'group':
  //       break;
  //     case 'groups':
  //       break;
  //     case 'game_view':
  //       break;
  //     case 'game_select':
  //       break;
  //     case 'game_write':
  //       break;
  //     case 'game_hear':
  //       break;
  //   }

  // },[mode]);

  useConstructor(() => {
    initData();


    GlobalData.funct.setStat = (new_stat) => {
      //setStat(new_stat);
      initData();
    };
  }, []);

  function initData() {

    GlobalData.data.styles = {};
    
    let sort_id = 0;

    GlobalData.data.groups.forEach((group) => {

      group.sort_id = sort_id;

      if(GlobalData.data.words[group.id] != undefined) {
        group.words_count = GlobalData.data.words[group.id].length;

        calcExams(group.id);

      } else {
        group.words_count = 0;
      }

      sort_id++;
    });

    setStyles(GlobalData.data.styles);
    setGroups(GlobalData.data.groups);
    setStat(GlobalData.data.stat);
  }

  function applyVoice(group_id) {

    words.forEach((word) => {
      
      let dir = "/resource/audio/"+voice+"/"+parseInt(word.id/1000)+"/";
      let file = dir+word.id;

      word.sound = {};
      word.sound.en = file+".mp3";

      if(word.v2)
        word.sound.v2 = file+"_v2.mp3";

      if(word.v2_alt)
        word.sound.v2_alt = file+"_v2_alt.mp3";

      if(word.v3)
        word.sound.v3 = file+"_v3.mp3";

      if(word.v3_alt)
        word.sound.v3_alt = file+"_v3_alt.mp3";

      if(undefined != word.audio_en)
        delete(word.audio_en);

      if(undefined != word.audio_v2)
        delete(word.audio_v2);

      if(undefined != word.audio_v3)
        delete(word.audio_v3);

      // if(word.example == undefined) {
      //   word.example = JSON.parse(word.example_js);
      // }

      // if(word.default_type_detal == undefined) {
      //   word.default_type_detal = JSON.parse(word.default_type_detal_js);
      // }
    });

    if(words[activeWordId] && words[activeWordId]) {
      preLoadSound(words[activeWordId]);
    }

    GlobalData.data.words[group_id].forEach((word) => {
      
      let dir = "/resource/audio/"+voice+"/"+parseInt(word.id/1000)+"/";
      let file = dir+word.id;

      word.sound = {};
      word.sound.en = file+".mp3";

      if(word.v2)
        word.sound.v2 = file+"_v2.mp3";

      if(word.v2_alt)
        word.sound.v2_alt = file+"_v2_alt.mp3";

      if(word.v3)
        word.sound.v3 = file+"_v3.mp3";

      if(word.v3_alt)
        word.sound.v3_alt = file+"_v3_alt.mp3";

      if(undefined != word.audio_en)
        delete(word.audio_en);

      if(undefined != word.audio_v2)
        delete(word.audio_v2);

      if(undefined != word.audio_v3)
        delete(word.audio_v3);

      // if(word.example == undefined) {
      //   word.example = JSON.parse(word.example_js);
      // }

      // if(word.default_type_detal == undefined) {
      //   word.default_type_detal = JSON.parse(word.default_type_detal_js);
      // }
    });
  }

  function selectGroup(group) {
    if(group) {
      applyVoice(group.id);
      setWords(GlobalData.data.words[group.id]);
      setActiveGroupId(group.id);
      setActiveGroup(group);
      setMode('group');

      document.querySelector('#main > .content').style.display = 'none';

      setActiveWordId(0);
    } else {
      setWords([]);
      setActiveGroupId(false);
      setActiveGroup(false);
      setMode('groups');

      document.querySelector('#main > .content').style.display = 'block';

      setActiveWordId(0);
    }
  }

  function prevWord() {
    let new_word_id = activeWordId;

    if(activeWordId > 0)
      new_word_id = activeWordId-1;
    else
      new_word_id = words.length-1;

    setActiveWordId(new_word_id);

    return new_word_id;
  }

  function nextWord() {

    let new_word_id = activeWordId;

    setIsError(false);

    if(mode == "game_write" || mode == "game_hear") {
      document.querySelector('.variants input.en').value = "";
      document.querySelector('.variants input.en').focus();

      if(words[activeWordId].v2)
        document.querySelector('.variants input.v2').value = "";

      if(words[activeWordId].v3)
        document.querySelector('.variants input.v3').value = "";
    }

    if(activeWordId < words.length-1)
      new_word_id = activeWordId+1;
    else
      new_word_id = 0;

    if(mode == "game_hear") {
      playWord(words[new_word_id]);
    }

    preLoadSound(words[new_word_id]);

    setActiveWordId(new_word_id);

    setTimeout(() => {
      setReadyAnswer(true);
    },500);

    return new_word_id;
  }

  function prevViewCard() {
    let curr_word_id = prevWord();

    playWord(words[curr_word_id]);
  }

  function nextViewCard() {
    let curr_word_id = nextWord();

    playWord(words[curr_word_id]);
  }

  function nextSelectCard() {
    let curr_word_id = nextWord();

    genRandomCards(curr_word_id, words);
  }

  function go2ViewWord(word_id) {
    playWord(words[word_id]);
    setActiveWordId(word_id);
    setMode("game_view");
  }

  function genRandomCards(word_id, group_words) {

    let act_word_en = {'key' : group_words[word_id].en, 'val' : group_words[word_id].en};

    if(group_words[word_id].v2)
      act_word_en.val += " "+group_words[word_id].v2;

    if(group_words[word_id].v2_alt)
      act_word_en.val += "/"+group_words[word_id].v2_alt;

    if(group_words[word_id].v3)
      act_word_en.val += " "+group_words[word_id].v3;

    if(group_words[word_id].v3_alt)
      act_word_en.val += "/"+group_words[word_id].v3_alt;

    let words_other = [];

    group_words.forEach((word) => {
      if(word.en != act_word_en.key) {

        let en_val = {'key' : word.en, 'val' : word.en};

        if(word.v2)
          en_val.val += " "+word.v2;

        if(word.v2_alt)
          en_val.val += "/"+word.v2_alt;

        if(word.v3)
          en_val.val += " "+word.v3;

        if(word.v3_alt)
          en_val.val += "/"+word.v3_alt;

        words_other.push(en_val);
      }
    });

    shuffle(words_other);

    let new_variants = [act_word_en, words_other[0], words_other[1]];

    shuffle(new_variants);

    setVariants(new_variants);
  }

  function startGame(game) {

    setIsError(false);

    let new_words = [];

    if(game != 'game_view') {
      setResults({'error':[], 'ok':[], 'proc':''});      
      new_words = cloneDeep(GlobalData.data.words[activeGroupId]);
      shuffle(new_words);
      setWords(new_words);

      if(game == 'game_select') {
        genRandomCards(activeWordId, new_words);
      }
    }

    if(game == 'game_view') {
      playWord(words[0]);
    }

    if(game == 'game_hear') {
      playWord(new_words[0]);
    }

    setMode(game);

    setTimeout(() => {
      setReadyAnswer(true);
    },500);
  }

  function exitGame() {
    setWords(GlobalData.data.words[activeGroupId]);
    setActiveWordId(0);
    setShowAllWords(true);
    setMode("group");
    setIsError(false);
  }

  const shuffle = (array) => {
    let m = array.length, t, i;

    // Пока есть элементы для перемешивания
    while (m) {

      // Взять оставшийся элемент
      i = Math.floor(Math.random() * m--);

      // И поменять его местами с текущим элементом
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }

    return array;
  }

  function play(file) {

    if(GlobalData.audio) {

      if(GlobalData.audio.stop != undefined)
        GlobalData.audio.stop();
    }

    GlobalData.audio = new Audio(file);

    GlobalData.audio.addEventListener("canplaythrough", (event) => {
      GlobalData.audio.volume = volume;
      GlobalData.audio.play();
    });
  }

  function preLoadSound(word) {
    word.audio_en = new Audio(word.sound.en);

    if(word.sound.v2) {
      word.audio_v2 = new Audio(word.sound.v2);
    }

    if(word.sound.v3) {
      word.audio_v3 = new Audio(word.sound.v3);
    }
  }

  function playWord(word) {

    if(!word.audio_en) {
      preLoadSound(word);

      word.audio_en.addEventListener("canplaythrough", (event) => {
        playWord(word);
      });

      return;
    }

    if(word.sound.v2) {
      setTimeout(() => {
        word.audio_v2.volume = volume;
        word.audio_v2.play();
      }, word.audio_en.duration*1000+50);
    }

    if(word.sound.v3) {
      setTimeout(() => {
        word.audio_v3.volume = volume;
        word.audio_v3.play();
      },word.audio_en.duration*1000+word.audio_v2.duration*1000+100);
    }

    word.audio_en.volume = volume;
    word.audio_en.play();
  }

  function selectVariant(variant) {

    if(isError || !readyAnswer)
      return;

    setReadyAnswer(false);

    let new_result = cloneDeep(results);

    let is_error = false;

    if(variant == words[activeWordId].en) {
      playWord(words[activeWordId]);

      if(new_result.ok.indexOf(words[activeWordId].id) < 0) {
        new_result.ok.push(words[activeWordId].id);
        new_result.proc = ", результат "+Math.round((((activeWordId+1)-new_result.error.length)/(activeWordId+1))*100)+'%';
        setResults(new_result);
      }

    } else {
      play('/resource/audio/oshybka-bip.mp3');

      is_error = true;

      if(new_result.error.indexOf(words[activeWordId].id) < 0) {
        new_result.error.push(words[activeWordId].id);
        new_result.proc = ", результат "+Math.round((((activeWordId+1)-new_result.error.length)/(activeWordId+1))*100)+'%';
        setResults(new_result);
      }
    }

    if(activeWordId < words.length-1) {
      if(is_error) {
        setIsError(true);
        setTimeout(() => {
          nextSelectCard();
        },2000);
      } else {
        nextSelectCard();
      }
    } else {
      saveStat(new_result);  
    }
  }

  function checkExam() {

    if(isError || !readyAnswer)
      return;

    setReadyAnswer(false);

    let is_true = true;

    let en_answer = document.querySelector('.variants input.en').value.trim();

    if(en_answer == 'gray')
      en_answer = 'grey';

    if(en_answer.toLowerCase() != words[activeWordId].en.toLowerCase())
      is_true = false;

    if(words[activeWordId].v2) {
      let v2_answer = document.querySelector('.variants input.v2').value.trim();

      if(!v2_answer)
        is_true = false;

      if(!(v2_answer.toLowerCase() == words[activeWordId].v2 || v2_answer.toLowerCase() == words[activeWordId].v2_alt)) {
        is_true = false;
      }
    }

    if(words[activeWordId].v3) {
      let v3_answer = document.querySelector('.variants input.v3').value.trim();

      if(!v3_answer)
        is_true = false;

      if(!(v3_answer.toLowerCase() == words[activeWordId].v3 || v3_answer.toLowerCase() == words[activeWordId].v3_alt)) {
        is_true = false;
      }
    }

    let new_result = cloneDeep(results);

    let is_error = false;

    if(is_true) {

      if(mode != "game_hear")
        playWord(words[activeWordId]);

      if(new_result.ok.indexOf(words[activeWordId].id) < 0) {
        new_result.ok.push(words[activeWordId].id);
        new_result.proc = ", результат "+Math.round((((activeWordId+1)-new_result.error.length)/(activeWordId+1))*100)+'%';
        setResults(new_result);
      }

    } else {
      play('/resource/audio/oshybka-bip.mp3');

      is_error = true;

      if(new_result.error.indexOf(words[activeWordId].id) < 0) {
        new_result.error.push(words[activeWordId].id);
        new_result.proc = ", результат "+Math.round((((activeWordId+1)-new_result.error.length)/(activeWordId+1))*100)+'%';
        setResults(new_result);
      }
    }

    if(activeWordId < words.length-1) {
      if(is_error) {
        setIsError(true);
        setTimeout(() => {
          nextWord();
        }, 2000);
      } else {
        nextWord();
      }
    } else {
      saveStat(new_result);      
    }
  }

  function saveStat(new_result) {

    post('/post/words/getuserstat/', {}, (ret_stat) => {

      // console.log(ret_stat.stat);
      // return;

      let new_stat = ret_stat.stat;
      GlobalData.data.stat = new_stat;
      initData();
      setStat(GlobalData.data.stat);

      let data_for_save = cloneDeep(new_stat);

      if(data_for_save['group_'+activeGroupId] == undefined)
        data_for_save['group_'+activeGroupId] = {};

      if(mode == "game_select")
        data_for_save['group_'+activeGroupId].select = {};

      if(mode == "game_write")
        data_for_save['group_'+activeGroupId].write = {};

      if(mode == "game_hear")
        data_for_save['group_'+activeGroupId].hear = {};

      let date = new Date;

      let date_str = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();

      data_for_save['group_'+activeGroupId].date = date_str;

      let result2save = new_result;

      delete(result2save.ok);

      result2save.proc = result2save.proc.replace(', результат ','');

      if(mode == "game_select")
        data_for_save['group_'+activeGroupId].select = result2save;

      if(mode == "game_write")
        data_for_save['group_'+activeGroupId].write = result2save;

      if(mode == "game_hear")
        data_for_save['group_'+activeGroupId].hear = result2save;

      data_for_save['group_'+activeGroupId].last_errors = cloneDeep(result2save.error);

      let params = {
        'data': data_for_save
      };

      setStat(data_for_save);
      GlobalData.data.stat = data_for_save;

      calcExams(activeGroupId);
      setStyles(GlobalData.data.styles);
      setGroups(GlobalData.data.groups);

      if(GlobalData.data.user) {
        post('/post/words/saveuserstat/', params, (ret) => {          
          exitGame();
        });
      } else {
        exitGame();
      }
    });
  }

  function calcExams(group_id) {
    if(GlobalData.data.stat['group_'+group_id] == undefined)
      return;

    let date_last = new Date(GlobalData.data.stat['group_'+group_id].date);
    let date_now = new Date();

    date_now.setHours(0);
    date_now.setMinutes(0);
    date_now.setSeconds(0);
    date_now.setMilliseconds(0);

    let last_exam = false;

    if(GlobalData.data.stat['group_'+group_id].days_from_last)
      last_exam = GlobalData.data.stat['group_'+group_id].days_from_last;

    GlobalData.data.stat['group_'+group_id].days_from_last = daysDiff(date_now, date_last);

    if(GlobalData.data.styles['group_'+group_id] == undefined)
      GlobalData.data.styles['group_'+group_id] = {};

    let diff_val = (100/14)*GlobalData.data.stat['group_'+group_id].days_from_last;

    if(diff_val > 100)
      diff_val = 100;

    let hsl_hue_val = 100-diff_val;

    GlobalData.data.styles['group_'+group_id].color = {'background':"HSL("+hsl_hue_val+" 100% 38%)"};

    if(GlobalData.data.stat['group_'+group_id].exams == undefined)
      GlobalData.data.stat['group_'+group_id].exams = {'first':false, 'second':false, 'third':false};

    if(GlobalData.data.stat['group_'+group_id].date && !GlobalData.data.stat['group_'+group_id].exams.first)
      GlobalData.data.stat['group_'+group_id].exams.first = GlobalData.data.stat['group_'+group_id].date;

    if(GlobalData.data.stat['group_'+group_id].date && !GlobalData.data.stat['group_'+group_id].exams.second) {
      if(GlobalData.data.stat['group_'+group_id].days_from_last == 0 && last_exam && last_exam >= 14) {
        GlobalData.data.stat['group_'+group_id].exams.second = GlobalData.data.stat['group_'+group_id].date;
        last_exam = false;
      }
    }

    if(GlobalData.data.stat['group_'+group_id].date && !GlobalData.data.stat['group_'+group_id].exams.third) {
      if(GlobalData.data.stat['group_'+group_id].days_from_last == 0 && last_exam && last_exam >= 14) {
        GlobalData.data.stat['group_'+group_id].exams.third = GlobalData.data.stat['group_'+group_id].date;
      }
    }
  }

  function inputKeyPress(event) {
    //console.log(event);
    if(event.charCode == 13 || event.code == 'Enter') {

      if(event.target.attributes.class.value == 'v3')
        checkExam();
      else {
        if(event.target.attributes.class.value == 'v2') {

          if(words[activeWordId].v3) {
            document.querySelector('.variants input.v3').focus();
            document.querySelector('.variants input.v3').click();
          } else {
            checkExam();
          }
        } else {
          if(event.target.attributes.class.value == 'en') {
            if(words[activeWordId].v2) {
              document.querySelector('.variants input.v2').focus();
              document.querySelector('.variants input.v2').click();
            } else {
              checkExam();   
            }
          }
        }
      }
    }
  }

  function prevGroup() {

    if(activeGroup.sort_id > 0)
      selectGroup(groups[activeGroup.sort_id-1]);
    else
      selectGroup(groups[groups.length-1]);
  }

  function nextGroup() {
    if(activeGroup.sort_id < groups.length-1)
      selectGroup(groups[activeGroup.sort_id+1]);
    else
      selectGroup(groups[0]);
  }
  
  return (
    <>

      <div className="top_settings">
        <div className="set_tip">
        Голос
        </div>
        <ToggleButtonGroup
              color="primary"
              value={voice}
              exclusive
              onChange={voiceChange}
              aria-label="voice"
        >
          <ToggleButton value="samantha">Samantha</ToggleButton>
          <ToggleButton value="ava">Ava</ToggleButton>
          <ToggleButton value="serena">Serena</ToggleButton>
        </ToggleButtonGroup>
        <div className="set_tip">
        Гучність
        </div>
        <Box sx={{ width: 150 }}>
          <Slider
            value={volume}
            step={0.1}
            marks
            min={0}
            max={1}
            onChange={changeVolume}
          />
        </Box>
        <div className="set_tip">
         
        </div>
        <ToggleButtonGroup
              color="primary"
              value={lang}
              exclusive
              onChange={langChange}
              aria-label="lang"
        >
          <ToggleButton value="ua">UA</ToggleButton>
          <ToggleButton value="ru">ru</ToggleButton>
        </ToggleButtonGroup>
      </div>

      {mode == 'groups' && 
        <div className="groups">
          <a className="back_to_main" href="/">на головну</a>
          {groups.map((group) => (
            <button className={`group ${group.words_count == 0 ? 'hide' : ''}`} onClick={() => selectGroup(group)} key={group.id}>
              <div className="name">{group.names[lang]}</div>
              <div className="words_count">{group.words_count} слів</div>
              <div className="group_results">
                {stat['group_'+group.id] &&
                <>
                  <div className="day_from_last_exam" style={styles['group_'+group.id].color}>
                  {stat['group_'+group.id].days_from_last == 0 && 
                    <>сьогодні</>
                  }
                  {stat['group_'+group.id].days_from_last == 1 && 
                    <>{stat['group_'+group.id].days_from_last} день тому</>
                  }
                  {(stat['group_'+group.id].days_from_last >= 2 && stat['group_'+group.id].days_from_last <= 4) && 
                   <>{stat['group_'+group.id].days_from_last} дні тому</>
                  }
                  {stat['group_'+group.id].days_from_last > 4 && 
                    <>{stat['group_'+group.id].days_from_last} днів тому</>
                  }
                  </div>
                  {stat['group_'+group.id].select && 
                    <div><span>обрано</span> {stat['group_'+group.id].select.proc}</div>
                  }
                  {stat['group_'+group.id].write && 
                    <div><span>написано</span> {stat['group_'+group.id].write.proc}</div>
                  }
                  {stat['group_'+group.id].hear && 
                    <div><span>на слух</span> {stat['group_'+group.id].hear.proc}</div>
                  }
                </>
                }
              </div>
            </button>
          ))}
        </div>
      }

      {(mode == 'group' && activeGroupId) && 
        <div className="group">

          <div className="back_to_groups" onClick={() => selectGroup(false)}>назад</div>

          <div className="group_info">
            <div className="name_block">
              <button className="prev_group" onClick={prevGroup}>&#8592;</button>
              <div className="name">{activeGroup.names[lang]}</div>
              <button className="next_group" onClick={nextGroup}>&#8594;</button>
            </div>
            <div className="group_results">
              {stat['group_'+activeGroupId] &&
              <>
                <div className="day_from_last_exam" style={styles['group_'+activeGroupId].color}>
                {stat['group_'+activeGroupId].days_from_last == 0 && 
                  <>сьогодні</>
                }
                {stat['group_'+activeGroupId].days_from_last == 1 && 
                  <>{stat['group_'+activeGroupId].days_from_last} день тому</>
                }
                {(stat['group_'+activeGroupId].days_from_last >= 2 && stat['group_'+activeGroupId].days_from_last <= 4) && 
                 <>{stat['group_'+activeGroupId].days_from_last} дні тому</>
                }
                {stat['group_'+activeGroupId].days_from_last > 4 && 
                  <>{stat['group_'+activeGroupId].days_from_last} днів тому</>
                }
                </div>
                {stat['group_'+activeGroupId].select && 
                  <div><span>обрано</span> {stat['group_'+activeGroupId].select.proc}</div>
                }
                {stat['group_'+activeGroupId].write && 
                  <div><span>написано</span> {stat['group_'+activeGroupId].write.proc}</div>
                }
                {stat['group_'+activeGroupId].hear && 
                  <div><span>на слух</span> {stat['group_'+activeGroupId].hear.proc}</div>
                }
              </>
              }
            </div>
          </div>

          <div className="games">
            <button className="game" onClick={() => startGame("game_view")}>Проглянути</button>
            <button className="game" onClick={() => startGame("game_select")}>Обрати з 3</button>
            <button className="game" onClick={() => startGame("game_write")}>Написати переклад</button>
            <button className="game" onClick={() => startGame("game_hear")}>Написати на слух</button>
          </div>

          <button className="showAllWords" onClick={() => setShowAllWords(!showAllWords)}>показати/сховати всі слова</button>          
          {showAllWords && 
          <div className="words_table">
            <table>
              <tbody>
                {words.map((word, word_key) => (
                  <tr className={`word ${word.default_type} ${stat['group_'+activeGroupId] && stat['group_'+activeGroupId].last_errors != undefined && stat['group_'+activeGroupId].last_errors.indexOf(word.id) >= 0 ? "error" : ""}`} key={word.id} >
                    <td className="word_id" onClick={() => go2ViewWord(word_key)}><button>#{word_key+1}</button></td>
                    <td className="word_en" onClick={() => go2ViewWord(word_key)}>
                    {word.en}

                    {word.v2 &&
                      <span className="verb">  {word.v2}</span>
                    }

                    {word.v2_alt &&
                      <span className="verb">/{word.v2_alt}</span>
                    }

                    {word.v3 &&
                      <span className="verb">  {word.v3}</span>
                    }

                    {word.v3_alt &&
                      <span className="verb">/{word.v3_alt}</span>
                    }

                    </td>
                    <td className="word_tr" onClick={() => playWord(word)}>
                    {word.tr &&
                    <>
                      |{word.tr}|
                    </>
                    }
                    </td>
                    <td className="word_translate" onClick={() => go2ViewWord(word_key)}>{word.def_translate}</td>
                  </tr>  
                ))}
              </tbody>
            </table>
          </div>
          }
        </div>
      }

      {(mode == 'game_view' && activeGroupId) && 
        <div className={`active_game ${isError ? 'error' : ''}`}>
          <button className="exit_game" onClick={() => exitGame()} >назад</button>

          <div className="results">{activeWordId+1} из {activeGroup.words_count}</div>

          <div className="main_game">

            <button className="prev_card" onClick={prevViewCard} >&#8592;</button>

            <div className={`word_card ${words[activeWordId].default_type}`}>
              <div className="wordId">#{activeWordId+1} - {words[activeWordId].default_type}</div>
              <div className={`word ${words[activeWordId].default_type}`}>
                <div className="word_en" onClick={() => playWord(words[activeWordId])}>
                  {words[activeWordId].en}

                  {words[activeWordId].v2 &&
                    <span className="verb"> {words[activeWordId].v2}</span>
                  }

                  {words[activeWordId].v2_alt &&
                    <span className="verb">/{words[activeWordId].v2_alt}</span>
                  }

                  {words[activeWordId].v3 &&
                    <span className="verb">  {words[activeWordId].v3}</span>
                  }

                  {words[activeWordId].v3_alt &&
                    <span className="verb">/{words[activeWordId].v3_alt}</span>
                  }

                </div>
                {words[activeWordId].tr &&
                  <div className="word_tr" onClick={() => playWord(words[activeWordId])}>|{words[activeWordId].tr}|</div>
                }

                <div className="word_translates">
                  {words[activeWordId].default_type_detal.map((translate, translate_key) => (
                    <div className={`translate ${translate[0]}`} key={translate_key}>
                      {words[activeWordId][translate[0]]}
                    </div>  
                  ))}
                </div>
              </div>  
            </div>

            <button className="next_card" onClick={nextViewCard} >&#8594;</button>
          </div>

          <div className="examples">
            {words[activeWordId].example.map((example_type) => (
              <div className={`example ${example_type[0]}`} key={example_type[0]}>
                {example_type[1].map((example, key_example) => (
                  <div className="example" key={key_example}>
                    <div className="ex">{key_example+1} - {example.ex}</div>
                    <div className="offer">{example.offer}</div>
                  </div>  
                ))}
              </div>
            ))}
          </div>
        </div>
      }

      {(mode == 'game_select' && activeGroupId) && 
        <div className={`active_game ${isError ? 'error' : ''}`}>
          <button className="exit_game" onClick={() => exitGame()}>назад</button>

          <div className="results">пройдено {activeWordId} з {activeGroup.words_count}, <span className="error">помилок {results.error.length}</span><span className="green">{results.proc}</span></div>

          <div className="main_game">

            <div className={`word_card ${words[activeWordId].default_type}`}>
              <div className="wordId">#{activeWordId+1} - {words[activeWordId].default_type}</div>
              <div className={`word ${words[activeWordId].default_type}`}>
                {isError &&
                <>
                  <div className="word_en" onClick={() => playWord(words[activeWordId])}>
                    {words[activeWordId].en}

                    {words[activeWordId].v2 &&
                      <span className="verb"> {words[activeWordId].v2}</span>
                    }

                    {words[activeWordId].v2_alt &&
                      <span className="verb">/{words[activeWordId].v2_alt}</span>
                    }

                    {words[activeWordId].v3 &&
                      <span className="verb">  {words[activeWordId].v3}</span>
                    }

                    {words[activeWordId].v3_alt &&
                      <span className="verb">/{words[activeWordId].v3_alt}</span>
                    }

                  </div>
                  {words[activeWordId].tr &&
                    <div className="word_tr" onClick={() => playWord(words[activeWordId])}>|{words[activeWordId].tr}|</div>
                  }
                </>
                }
                <div className="word_translates">
                  {words[activeWordId].default_type_detal.map((translate, translate_key) => (
                    <div className={`translate ${translate[0]}`} key={translate_key}>
                      {words[activeWordId][translate[0]]}
                    </div>  
                  ))}
                </div>
              </div>  
            </div>

            <div className={`variants ${readyAnswer ? '' : 'notPoint'}`}>
              {variants.map((variant) => (
                <button className="variant" key={variant.key} onClick={() => selectVariant(variant.key)}>
                  {variant.val}
                </button>  
              ))}
            </div>

          </div>
        </div>
      }

      {((mode == 'game_write' || mode == 'game_hear') && activeGroupId) && 
        <div className={`active_game ${isError ? 'error' : ''}`}>
          <button className="exit_game" onClick={() => exitGame()}>назад</button>

          <div className="results">пройдено {activeWordId} з {activeGroup.words_count}, <span className="error">помилок {results.error.length}</span><span className="green">{results.proc}</span></div>

          <div className="main_game">
            <div className={`word_card ${words[activeWordId].default_type}`}>
              <div className="wordId">#{activeWordId+1} - {words[activeWordId].default_type}</div>
              {(mode == 'game_hear' && !isError) &&
                <button className="play_game_sound" onClick={() => playWord(words[activeWordId])}>повторити</button>
              }
              <div className={`word ${words[activeWordId].default_type}`}>
                {isError &&
                <>
                  <div className="word_en" onClick={() => playWord(words[activeWordId])}>
                    {words[activeWordId].en}

                    {words[activeWordId].v2 &&
                      <span className="verb"> {words[activeWordId].v2}</span>
                    }

                    {words[activeWordId].v2_alt &&
                      <span className="verb">/{words[activeWordId].v2_alt}</span>
                    }

                    {words[activeWordId].v3 &&
                      <span className="verb">  {words[activeWordId].v3}</span>
                    }

                    {words[activeWordId].v3_alt &&
                      <span className="verb">/{words[activeWordId].v3_alt}</span>
                    }

                  </div>
                  {words[activeWordId].tr &&
                    <div className="word_tr" onClick={() => playWord(words[activeWordId])}>|{words[activeWordId].tr}|</div>
                  }
                </>
                }

                {(mode == 'game_write' || isError) &&
                <div className="word_translates">
                  {words[activeWordId].default_type_detal.map((translate, translate_key) => (
                    <div className={`translate ${translate[0]}`} key={translate_key}>
                      {words[activeWordId][translate[0]]}
                    </div>  
                  ))}
                </div>
                }
              </div>  
            </div>

            <div className={`variants ${readyAnswer ? '' : 'notPoint'}`}>
              <input className="en" type="input" spellcheck="false" autofocus onKeyPress={inputKeyPress} />

              {words[activeWordId].v2 &&
                <>
                  <div className="write_tip">verb v2, або альтернативну форму v2</div>
                  <input className="v2" type="input" spellcheck="false" onKeyPress={inputKeyPress} />
                </>
              }

              {words[activeWordId].v3 &&
                <>
                  <div className="write_tip">verb v3, або альтернативну форму v3</div>
                  <input className="v3" type="input" spellcheck="false" onKeyPress={inputKeyPress} />
                </>
              }

              <button className="check" onClick={checkExam}>перевірити</button>
            </div>
          </div>
        </div>
      }
    </>
  );
}